import { useRef, ComponentPropsWithoutRef } from "react"
import { Button, buttonVariants } from "../ui/button"
import { UploadIcon } from "lucide-react"
import { cn } from "../../lib/utils"
import { type VariantProps } from "class-variance-authority"

interface FileInputProps extends ComponentPropsWithoutRef<"div">, Pick<VariantProps<typeof buttonVariants>, "variant"> {
  onFileLoad: (file: File) => void
  acceptedExtensions: string[]
  file?: File
  placeholder?: string
}

const FileInput = ({
  onFileLoad,
  acceptedExtensions,
  file,
  placeholder = "Charger un fichier",
  className,
  variant = "default",
  ...props
}: FileInputProps) => {
  const fileInputRef = useRef<HTMLInputElement>(null)

  const isFileExtensionAccepted = (fileName: string) =>
    acceptedExtensions.some(ext => fileName.toLowerCase().endsWith(ext.toLowerCase()))

  const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0]
    if (file && isFileExtensionAccepted(file.name)) {
      onFileLoad(file)
    }
  }

  const handleButtonClick = () => {
    fileInputRef.current?.click()
  }

  const acceptAttribute = acceptedExtensions.join(",")

  return (
    <div className={cn(className)} {...props}>
      <input
        ref={fileInputRef}
        type="file"
        accept={acceptAttribute}
        onChange={handleFileChange}
        className="hidden"
      />
      <Button
        onClick={handleButtonClick}
        variant={variant}
        className="w-full"
      >
        <UploadIcon className="w-4 h-4 mr-2" />
        {!!file ? `Fichier chargé: ${file.name}` : placeholder}
      </Button>
    </div>
  )
}

export {
  FileInput
}
